import { error, finish } from '../../../modules/grades/actions/get-list';

function buildValue(value) {
    if (value === null) {
        return null;
    }
    if (value === undefined) {
        return undefined;
    }

    return $appState.configState.precision.newFromOld(value).value;
}

export function request(dispatch, { sportId }) {
    $appState.sdkStaff.getSportsGrades(sportId).then(
        data => {
            $appState.sdkStaff.getSport(sportId).then(
                sport => {
                    data = data.map(grade => {
                        grade.default = parseInt(grade.id, 10) === parseInt(sport.defaultGrade.id, 10);

                        grade.defaultLimits = {
                            liabilityLimit: buildValue(grade.defaultLimits.liabilityLimit),
                            maxBet: buildValue(grade.defaultLimits.maxBet),
                            maxMultipleBet: buildValue(grade.defaultLimits.maxMultipleBet),
                            maxWin: buildValue(grade.defaultLimits.maxWin)
                        };

                        
                        const marketLimits = {};

                        for (const marketLimitsKey in grade.marketLimits) {
                            marketLimits[marketLimitsKey] = {
                                liabilityLimit: buildValue(grade.marketLimits[marketLimitsKey].liabilityLimit),
                                maxBet: buildValue(grade.marketLimits[marketLimitsKey].maxBet),
                                maxMultipleBet: buildValue(grade.marketLimits[marketLimitsKey].maxMultipleBet),
                                maxWin: buildValue(grade.marketLimits[marketLimitsKey].maxWin)
                            };
                        }
                        
                        
                        grade.marketLimits = marketLimits;
                        
                        return grade;

                    });

                    dispatch(finish(sportId, data));
                },
                () => dispatch(finish(sportId, data))
            );
        },
        errors => dispatch(error(sportId, errors))
    );
}
